import React from "react";
import { Card, Tag } from "antd";
import type { NoticePeriodTrackingDto } from "../../Utils/types";
import { formatExitDateDisplay } from "../../Utils/exitDateUtils";

function displayStatusLabel(s: string | undefined): string {
  switch (s) {
    case "NOTICE_PERIOD_ACTIVE":
      return "Notice Period Active";
    case "EXIT_IN_PROGRESS":
      return "Exit in progress";
    default:
      return "Notice";
  }
}

export interface NoticePeriodCardProps {
  tracking: NoticePeriodTrackingDto;
  className?: string;
}

/**
 * Employee notice-period summary when `noticePeriodTracking` is present on my-exit.
 */
const NoticePeriodCard: React.FC<NoticePeriodCardProps> = ({
  tracking,
  className,
}) => {
  const badge = (
    <Tag color="blue">{displayStatusLabel(tracking.displayStatus)}</Tag>
  );

  return (
    <Card
      size="small"
      title={
        <span className="flex flex-wrap items-center gap-2">
          Notice Period
          {badge}
        </span>
      }
      className={className}
    >
      <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm text-slate-700 m-0">
        <div>
          <dt className="text-slate-500 text-xs">Notice start</dt>
          <dd className="m-0 font-medium">
            {formatExitDateDisplay(tracking.noticePeriodStartDate)}
          </dd>
        </div>
        {tracking.approvedLastWorkingDay ? (
          <div>
            <dt className="text-slate-500 text-xs">Approved last date</dt>
            <dd className="m-0 font-medium">
              {formatExitDateDisplay(tracking.approvedLastWorkingDay)}
            </dd>
          </div>
        ) : null}
        <div>
          <dt className="text-slate-500 text-xs">Last working date</dt>
          <dd className="m-0 font-medium">
            {formatExitDateDisplay(tracking.actualLastWorkingDay)}
          </dd>
        </div>
        {/* <div>
          <dt className="text-slate-500 text-xs">Remaining calendar days</dt>
          <dd className="m-0 font-medium">
            {typeof tracking.remainingCalendarDays === "number" &&
            tracking.remainingCalendarDays >= 0
              ? String(tracking.remainingCalendarDays)
              : "—"}
          </dd>
        </div> */}
      </dl>
    </Card>
  );
};

export default NoticePeriodCard;
